import ajaxCrud from "@/services/ajaxCrud";
import { endpointMappingAvvenimento } from "../../../constants";

export default {
  getAll(cb = null) {
    ajaxCrud.getAll(endpointMappingAvvenimento, cb);
  },

  get(id, cb) {
    ajaxCrud.get(endpointMappingAvvenimento, id, cb);
  },

  update(id, data = {}, cb) {
    ajaxCrud.update(endpointMappingAvvenimento, id, data, cb);
  },

  create(data = {}, cb) {
    ajaxCrud.create(endpointMappingAvvenimento, data, cb);
  },

  delete(id, cb) {
    ajaxCrud.delete(endpointMappingAvvenimento, id, cb);
  },

  massDelete(ids, cb) {
    ajaxCrud.massDelete(endpointMappingAvvenimento, ids, cb);
  },

  massUpdate(rows, cb) {
    ajaxCrud.massUpdate(endpointMappingAvvenimento, rows, cb);
  },
};
